var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuPackageManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5404 0.932898C10.8258 0.772367 11.1742 0.772367 11.4596 0.932898L21.4596 6.5579C21.7548 6.72395 21.9375 7.03631 21.9375 7.375V18.625C21.9375 18.9637 21.7548 19.2761 21.4596 19.4421L11.4596 25.0671C11.1742 25.2276 10.8258 25.2276 10.5404 25.0671L0.54038 19.4421C0.245183 19.2761 0.0625 18.9637 0.0625 18.625V7.375C0.0625 7.03631 0.245183 6.72395 0.54038 6.5579L10.5404 0.932898ZM1.9375 8.97798L10.0625 13.5483V22.647L1.9375 18.0767V8.97798ZM11.9375 22.647L20.0625 18.0767V8.97798L11.9375 13.5483V22.647ZM11 11.9244L19.0878 7.375L15.8344 5.54498L8.0428 10.2609L11 11.9244ZM6.16597 9.20522L13.9576 4.48926L11 2.82564L2.91225 7.375L6.16597 9.20522Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPackageManagement);
export default __webpack_public_path__ + "static/media/menu_package_management.b3c6c8fa3657f45d26b10af0d09479ab.svg";
export { ForwardRef as ReactComponent };